export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? 'dev';
